import React, { useContext, useEffect } from "react";
const ProviderContext = React.createContext();
export class Provider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      contentWidth: null,
    };
  }

  updateContentWidth = (newWidth = null) => {
    this.setState({ contentWidth: newWidth });
  };

  update = (val, callBackFunc) => {
    this.setState({ ...val }, () => {
      if (callBackFunc) callBackFunc();
    });
  };
  render() {
    return (
      <ProviderContext.Provider
        value={{
          update: this.update,
          ownProps: this.props,
          updateContentWidth: this.updateContentWidth,
          ...this.state,
        }}>
        {this.props.children}
      </ProviderContext.Provider>
    );
  }
}
export class Consumer extends React.Component {
  render() {
    return (
      <ProviderContext.Consumer>
        {(store) => this.props.children(store)}
      </ProviderContext.Consumer>
    );
  }
}

export const useContentWidth = (newContentWidth) => {
  const { updateContentWidth } = useContext(ProviderContext);

  useEffect(() => {
    updateContentWidth(newContentWidth);
    return () => {
      updateContentWidth();
    };
  }, []);
};
